<template>
  <div>
    <div class="row" v-for="(document, key) in documents" :key="key">

      <template v-if="key === 0 && author.affiliation">
        <div class="col-xs-12 well">

          <div class="clearfix"></div>

          <div class="row">
            <div class="col-md-2 col-xs-12 col-sm-3 item-label">
              <span>Information : </span>
            </div>
            <div class="col-md-10 col-xs-12 col-sm-9">

              <div class="row">
                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">Status</label>
                    <span class="col-xs-6" v-if="author.affiliation.status_str">{{author.affiliation.status_str}}</span>
                    <span class="col-xs-6" v-else>n.a.</span>

                  </div>
                </div>

                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">Country</label>
                    <span class="col-xs-6" v-if="author.affiliation.country">{{author.affiliation.country}}</span>
                    <span class="col-xs-6" v-else>n.a.</span>
                  </div>
                </div>

                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">City</label>
                    <span class="col-xs-6" v-if="author.affiliation.city">{{author.affiliation.city}}</span>
                    <span class="col-xs-6" v-else>n.a.</span>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 10px">
                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">Incorp Date</label>
                    <span class="col-xs-6" v-if="author.affiliation.incorporation_date">{{author.affiliation.incorporation_date}}</span>
                    <span class="col-xs-6" v-else>n.a.</span>
                  </div>
                </div>
                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">Turnover</label>
                    <span class="col-xs-6" v-if="author.affiliation.turnover">{{Math.round(author.affiliation.turnover) }} K €</span>
                    <span class="col-xs-6" v-else>n.a.</span>

                  </div>
                </div>
                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">Nb Employees</label>
                    <span class="col-xs-6" v-if="author.affiliation.nb_employees">{{author.affiliation.nb_employees}}</span>
                    <span class="col-xs-6" v-else>n.a.</span>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-top: 10px">
                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">Category</label>
                    <span class="col-xs-6" v-if="author.affiliation.category">{{author.affiliation.category}}</span>
                    <span class="col-xs-6" v-else>n.a.</span>
                  </div>
                </div>
                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">Website</label>
                    <span class="col-xs-6" v-if="author.affiliation.website"><a :href="author.affiliation.website" target="_blank">{{author.affiliation.website}}</a></span>
                    <span class="col-xs-6" v-else>n.a.</span>
                  </div>
                </div>
                <div class="col-xs-4">
                  <div class="row">
                    <label class="col-xs-6">Nb Patents</label>
                    <span class="col-xs-6" v-if="author.affiliation.nb_patents">{{author.affiliation.nb_patents}}</span>
                    <span class="col-xs-6" v-else>n.a.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 15px">
            <div class="col-md-2 col-xs-12 col-sm-3 item-label">
              <span>Description : </span>
            </div>
            <div class="col-md-10 col-xs-12 col-sm-9">
              <span v-if="author.affiliation.overview || author.affiliation.trade_description">{{author.affiliation.overview}}; {{author.affiliation.trade_description}}</span>
              <span v-else> No description available</span>
            </div>

          </div>
        </div>
      </template>
      <div class="col-xs-12 well" v-if="document.title === 'Aster Capital'">
        <div class="row">
          <div class="col-md-2 col-xs-12 col-sm-3 item-label">
            <span>Aster Website: </span>
          </div>
          <div class="col-md-10 col-xs-12 col-sm-9 text-justify">
            <a :href="document.link" target="_blank">{{document.link}} </a>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<style>
  .item-label {
    font-weight: bold;
  }

  .coAuthors-divider + .coAuthors-divider:before {
    content: ", ";
  }
</style>
<script>

import DocumentAction from './DocumentAction'

export default {
  name: 'DocumentsSECompany',
  components: {DocumentAction},
  props: ['value', 'author', 'context', 'pubDateSelected'],
  watch: {
    company: function (author) {
      // console.log('DocumentAuthor author', author)
    },
    value: function (val) {
      // console.log('update documents', val)
      this.documents = val
    },
    pubDateSelected: function (pubDateSelected) {
      let documents = this.author.docs

      if (pubDateSelected.length !== 0) {
        documents = documents.filter((document) => {
          let date = new Date(document.pubDate).getFullYear()
          let tmpYear = pubDateSelected.find((year) => {
            return date === year.name
          })
          return typeof tmpYear !== 'undefined'
        })
      }
      this.documents = documents
    }
  },
  data () {
    return {
      documents: null
    }
  },
  beforeMount () {
    this.documents = this.value
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentsSECompany.vue